
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11z"}}),_c('path',{attrs:{"d":"M12 15.682c-2.137 0-4.183.99-5.613 2.717a.5.5 0 00.769.638c1.24-1.497 3.006-2.355 4.844-2.355 1.809 0 3.559.845 4.804 2.318a.5.5 0 00.764-.644c-1.435-1.699-3.464-2.674-5.567-2.674zm4.182-7.319a1.546 1.546 0 100 3.09 1.546 1.546 0 000-3.09zm0 2.091a.546.546 0 110-1.092.546.546 0 010 1.092zm-8.363 1a1.547 1.547 0 000-3.091 1.546 1.546 0 000 3.091zm0-2.091a.546.546 0 11-.002 1.092.546.546 0 01.002-1.092z"}})])
          )
        }
      }
    